import { ActionType } from "@ms/uno-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for WorkflowCopilotStore, for use in the registry */ export const WorkflowCopilotStoreActionTypes = [
    ActionType.ProjectManagerWorkflowClientStateUpdateAction
];
